import React, { useState } from "react";
import Div100vh from "react-div-100vh";
import GoBackButton from "../common/buttons/GoBackButton";
import bgBhai from "@/assets/images/bubbles.jpg";
import BgVideo from "@/assets/videos/conog_bg.mp4";

const landlordBenefits = [
  {
    title: "Get Advance Rent",
    description: "of the entire lease (Non-Refundable)",
    image: "/path-to-image-3.jpg",
  },
  
  {
    title: "We Find New Tenants",
    description: "on every renewal & save money on brokerage",
    image: "/path-to-image-5.jpg",
  },
  {
    title: "Normal Rent Agreement",
    description: "No master-lease/Sub-lease",
    image: "/path-to-image-6.jpg",
  },
  {
    title: "Move In & Move Out Report",
    description: "along with deep cleaning & full management",
    image: "/path-to-image-7.jpg",
  },
];

const tenantBenefits = [
  {
    title: "ZERO Security Deposit",
    description:
      "We trust our members to not damage the house or vacate during the lock-in period.",
    image: "/path-to-image-1.jpg",
  },
  {
    title: "ZERO Membership Charges",
    description:
      "You pay the same rent agreed with your landlord simply as a No-Cost EMI. Deducted monthly just like your Netflix subscription.",
    image: "/path-to-image-2.jpg",
  },
];

export default function ClubBenefits({ setBenefitsDrawer }) {
  const [selectedTab, setSelectedTab] = useState("landlord");

  const [touchStartX, setTouchStartX] = useState(null);
  const [touchEndX, setTouchEndX] = useState(null);
  const [touchStartY, setTouchStartY] = useState(null);
  const [touchEndY, setTouchEndY] = useState(null);

  const minSwipeDistance = 50;
  const minSwipeDistanceY = 50;

  const onTouchStart = (e) => {
    setTouchEndX(null);
    setTouchStartX(e.targetTouches[0].clientX);
    setTouchEndY(null);
    setTouchStartY(e.targetTouches[0].clientY);
  };

  const onTouchMove = (e) => {
    setTouchEndX(e.targetTouches[0].clientX);
    setTouchEndY(e.targetTouches[0].clientY);
  };

  const onTouchEnd = () => {
    if (!touchStartX || !touchEndX || !touchStartY || !touchEndY) return;

    const distanceX = touchStartX - touchEndX;
    const isLeftSwipe = distanceX > minSwipeDistance;
    const isRightSwipe = distanceX < -minSwipeDistance;

    const distanceY = touchStartY - touchEndY;
    const isDownSwipe = distanceY < -minSwipeDistanceY;

    if (isLeftSwipe) setSelectedTab("landlord");
    if (isRightSwipe) setSelectedTab("tenant");
    if (isDownSwipe) setBenefitsDrawer((prevState) => !prevState);
  };

  const benefits = selectedTab === "tenant" ? tenantBenefits : landlordBenefits;

  return (
    <Div100vh
      className="flex flex-col space-y-subheading-input bg-[#010101] "
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(1, 1, 1, 1) 0%, rgba(1, 1, 1, 0) 100%), url(${bgBhai})`,
      }}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {/* Background Video */}
      {/* <video
        className="absolute inset-0 w-full h-full object-cover z-0"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={BgVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}
      <div className="p-4 px-10 sm:p-10 flex flex-col gap-3 sm:gap-6 overflow-scroll sm:overflow-scroll">
        <GoBackButton
          customBackSubmit={() => setBenefitsDrawer((prevState) => !prevState)}
        />
        <span className="text-xl sm:text-2xl font-medium">CLUB Benefits</span>
        <div className="flex justify-between my-2">
          <button
            onClick={() => setSelectedTab("tenant")}
            className={`text-xs min-w-max px-4 py-2 ${
              selectedTab === "tenant"
                ? "text-white border-b-2 border-white"
                : "text-gray-400"
            }`}
          >
            Tenant Benefits
          </button>
          <button
            onClick={() => setSelectedTab("landlord")}
            className={`text-xs min-w-max px-4 py-2 ${
              selectedTab === "landlord"
                ? "text-white border-b-2 border-white"
                : "text-gray-400"
            }`}
          >
            Landlord Benefits
          </button>
        </div>
        <div className="space-y-2 sm:space-y-4 ">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="flex flex-col bg-[#444] bg-opacity-30 p-4 rounded-lg backdrop-blur-2xl border border-[#888]/50"
            >
              <div className=" sm:gap-2 flex flex-col">
                <h2 className="text-xs sm:text-lg font-medium">
                  {benefit.title}
                </h2>
                <p className="text-xs font-light sm:text-normal text-gray-300">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Div100vh>
  );
}
